import { Link } from "react-router-dom";
import { Section, SectionHeading } from "@/components/Bits";
import bsesLogo from "@/assets/bses.jpg";
import dcaLogo from "@/assets/dca.jpg";

// Institutions that placed their trust in YTCA and made specific initiatives
// possible. Each card links through to its related Achievement story.
const COLLABORATORS = [
  {
    name: "BSES",
    note: "Made Colours of Delhi possible",
    logo: bsesLogo,
    to: "/blog/colours-of-delhi-story",
    testid: "collaborator-bses",
  },
  {
    name: "Delhi Collage of Art",
    note: "Supported our Live Studies",
    logo: dcaLogo,
    to: "/blog/live-study-workshop",
    testid: "collaborator-delhi-college-of-art",
  },
];

const LogoCard = ({ item }) => (
  <Link
    to={item.to}
    className="group mx-3 flex min-w-[280px] items-center gap-4 rounded-2xl border border-border bg-card px-5 py-4 transition-colors hover:border-primary/40"
    data-testid={item.testid}
    aria-label={`${item.name} — ${item.note}. Read the story.`}
  >
    <span className="flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white p-2">
      <img src={item.logo} alt={`${item.name} logo`} className="max-h-full max-w-full object-contain" />
    </span>
    <div className="leading-tight">
      <p className="font-display text-lg font-semibold tracking-tight">{item.name}</p>
      <p className="mt-0.5 text-xs uppercase tracking-[0.12em] text-muted-foreground">{item.note}</p>
      <span className="mt-1 inline-flex items-center gap-1 text-xs font-medium text-primary transition-transform group-hover:translate-x-1">
        Read the story →
      </span>
    </div>
  </Link>
);

export const Collaborators = () => {
  // Repeat so the marquee has enough width; render the row twice for a seamless -50% loop.
  const row = [...COLLABORATORS, ...COLLABORATORS, ...COLLABORATORS, ...COLLABORATORS];

  return (
    <Section id="collaborations">
      <SectionHeading
        eyebrow="With Gratitude"
        title="Made possible by those who believed in us."
        intro="Two institutions placed their trust in YTCA early on. BSES made our Colours of Delhi initiative possible, and Delhi Collage of Art helped bring our Live Studies to life."
      />
      <div className="marquee-viewport marquee-mask mt-10 overflow-hidden" data-testid="collaborators-marquee">
        <div className="marquee-track py-1">
          {row.map((item, i) => (
            <LogoCard key={`a-${i}`} item={item} />
          ))}
          {row.map((item, i) => (
            <LogoCard key={`b-${i}`} item={item} />
          ))}
        </div>
      </div>
    </Section>
  );
};
